import React from "react";
import styles from "../forgetPasswordPage.module.css";
import { useHttpClient } from "hooks/useHttpClient";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const EmailScreen = (props) => {
  const navigate = useNavigate();
  const { error, sendRequest } = useHttpClient();

  const onFinish = async (values) => {
    try {
      // const loginResult = 
      await sendRequest(
        "/auth/password/forget-password",
        "POST",
        JSON.stringify({
          email: values.email,
        })
      );
      if (!error) {
        props.setScreen(props.screen + 1);
        props.setEmail(values.email);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className={styles.loginDiv}>
      <h1>Forget Password</h1>
      <p className={styles.signupNavigation}>
        Enter the email associated with you account and we will send an email
        with instructions on how to reset your password.
      </p>
      <Form
        name="basic"
        style={{ maxWidth: "100%" }}
        onFinish={onFinish}
        autoComplete="on"
      >
        <Form.Item
          name="email"
          rules={[
            {
              type: "email",
              message: "The input is not valid Email!",
            },
            {
              required: true,
              message: "Please input your Email!",
            },
          ]}
          className={styles.formItem}
        >
          <Input placeholder="Email" className={styles.input} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className={styles.button}>
            Reset Password
          </Button>
        </Form.Item>
        <Button
          type="primary"
          className={styles.backButton}
          onClick={() => navigate("/sign-in")}
        >
          <ArrowLeftOutlined /> Back to Sign in
        </Button>
      </Form>
    </div>
  );
};

export default EmailScreen;
